const state = {
    userSta: null, // 1 新增  2 修改
    useritem: null, //单个用户信息
    newtotal: null, //新增用户数量
    usersListUpdate: 0
}
const getters = {
    userSta(state) {
        return state.userSta
    },
    useritem(state) {
        return state.useritem
    },
    newtotal(state) {
        return state.newtotal
    },

    usersListUpdate(state){
        return state.usersListUpdate
    }
}
const mutations = {
    changeuserSta(state, userSta) {
        state.userSta = userSta
    },
    changeuseritem(state, useritem) {
        state.useritem = useritem
    },
    changenewtotal(state, newtotal) {
        state.newtotal = newtotal
    },

    updateUsersList(state, usersListUpdate){
        state.usersListUpdate = usersListUpdate
    }

}
const actions = {
    changeuserSta({
        commit
    }, num) {
        commit('changeuserSta', num)
    },
    changeuseritem({
        commit
    }, num) {
        commit('changeuseritem', num)
    },
    changenewtotal({
        commit
    }, num) {
        commit('changenewtotal', num)
    },

    updateUsersList({
        commit
    }, num) {
        commit('updateUsersList', num)
    },

}
export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}